import { ClientUserState } from '../ClientUserState.ts';
export function isGameModeLockedForUser(gameModeData) {
    var _ClientUserState_userState;
    if (!gameModeData.isGameModePremium()) return false;
    if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasAccessToPremiumMode(gameModeData)) return false;
    return true;
}
